export default {
  version: 'master',
  compilation: '289768'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1477
// module chunks = 22